<div *ngIf="!loading" class="formGroup">
	<div  class="container-fluid">
		<div class="row">
			<div class="col-xs-12 col-sm-12 col-md-12 col-lg-12" style="margin-top: 22px;margin-bottom: 9px;">
				<div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 vehicle-slice-title">
				<a routerLink="/finance/payment-calculator">
					<span class="glyphicon glyphicon-menu-left g-menu-left"></span>

				<div class="col1Header">ALL VEHICLES</div>
				</a>
				</div>
			</div>
		</div>
		<div class="row">
			<div class="col2Header">SELECT TRIM: {{displayName}}</div>
			<div class="col-12 white-area">
				<div #vehSliceList *ngFor="let slice of vehicleListByModel"
					 class="col-xs-6 col-md-4 col-sm-4 col-lg-4 cardStyle">

						<div
	(click)="openEstimationWindow(slice.year,slice.name,slice.make,slice.ImageToken,slice.Pricing.BaseMSRP)"
	(keyup)="onDivKeyUp($event, slice.year,slice.name,slice.make,slice.ImageToken,slice.Pricing.BaseMSRP)">
							<ul class="image-ul">
							<li><img [src]="slice.vehicleImage"  [srcset]="slice.vehicleImage"
									 sizes="(max-width: 600px) 100vw, (max-width: 1200px) 50vw, 33vw"
									 alt="..." class="vehicle-image-size" loading="lazy">
							</li>
							<li class="mat--model--left">{{slice.year}}</li>
							<li class="mat--model--right">
								{{slice.name}}
							<li>
							</li>
					</ul>
							<div class="veh-image-hr-line">
							</div>
							<ul class="image-ul">
							<li class="mat--model--price">
								<span class="model--price--label">Starting
								at {{slice.Pricing.BaseMSRP | wholeDollar}}
									<a (click)="$event.stopPropagation()"
									   aria-label="Button that displays a tooltip in various positions"
									   class="msrp--disclosure"
									   mat-raised-button
									   ngbPopover="{{ToolTipConstants.TRIM_VEHICLE_TOOLTIP}}"
									   placement="auto"
									   [triggers]="trimPopoverTriggers"
									   autoClose=true>

									1
								</a></span>
							</li>
					</ul>
						</div>
				</div>
			</div>
		</div>
		</div>
</div>
<mat-spinner class="loaderStyle" *ngIf="loading"></mat-spinner>

<mat-spinner class="loaderStyle" *ngIf="loading"></mat-spinner>


